import { render } from "./InitiateGameCreate.vue?vue&type=template&id=35cd4bc1"
import script from "./InitiateGameCreate.vue?vue&type=script&lang=js"
export * from "./InitiateGameCreate.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__